(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // Della Mattia : pastilles de pagination du slider mobile du hero.
  // Elles ne sont visibles qu'en dessous de 750px, la CSS s'en charge.
  (function () {
    function initHeroSlider(track) {
      if (track.dataset.dmSlider === '1') return;
      var slides = track.querySelectorAll('.hero__media-wrapper');
      if (slides.length < 2) return;
      track.dataset.dmSlider = '1';

      var dots = document.createElement('div');
      dots.className = 'dm-hero-dots';

      slides.forEach(function (slide, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'dm-hero-dot' + (index === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Photo ' + (index + 1));
        dot.addEventListener('click', function () {
          track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
        });
        dots.appendChild(dot);
      });

      var grid = track.closest('.hero__media-grid') || track.parentNode;
      grid.appendChild(dots);

      var buttons = dots.querySelectorAll('.dm-hero-dot');
      track.addEventListener(
        'scroll',
        function () {
          if (!track.clientWidth) return;
          var current = Math.round(track.scrollLeft / track.clientWidth);
          buttons.forEach(function (dot, index) {
            dot.classList.toggle('is-active', index === current);
          });
        },
        { passive: true }
      );
    }

    function initAll() {
      document.querySelectorAll('.hero__media-track').forEach(initHeroSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (function () {
    var SELECTORS = ['.product-details .text-block'];
    var CM_TO_IN = 0.393700787;

    function toInches(value, unit) {
      var cm = unit === 'mm' ? value / 10 : unit === 'm' ? value * 100 : value;
      var inches = cm * CM_TO_IN;
      var rounded = Math.round(inches * 10) / 10;
      return rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1);
    }

    var RE = /(\d+(?:[.,]\d+)?)\s?(mm|cm|m)\b(?!\s?[²2])/gi;

    function processNode(root) {
      if (!root || root.dataset.inConverted === '1') return;

      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);

      nodes.forEach(function (node) {
        var text = node.nodeValue;
        if (!RE.test(text)) return;
        RE.lastIndex = 0;

        var converted = text.replace(RE, function (match, num, unit) {
          var v = parseFloat(num.replace(',', '.'));
          return toInches(v, unit.toLowerCase()) + ' in';
        });

        if (converted === text) return;

        var span = document.createElement('span');
        span.className = 'dimensions-inch';
        span.style.display = 'block';
        span.style.opacity = '0.65';
        span.textContent = converted.trim();

        node.parentNode.insertBefore(span, node.nextSibling);
      });

      root.dataset.inConverted = '1';
    }

    function run() {
      SELECTORS.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(processNode);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
